<template>
    <div>

        <Row :gutter="10">
            <Col span="4">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: cityFilter}"
                             :debounce="500" :skip="skipCity">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Order City" v-model="city" :clearable="true" element-id="city"
                                          @on-clear="onClearCity()" @on-search="onSearchCity($event)">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city)">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col span="4">
              <Select v-model="selectedStatus" placeholder="Status" clearable>
                <Option v-for="status in ['Active', 'Inactive', 'Pending']" :value="status" :label="status" :key="status">
                  <div class="ivu-select-item-div"> {{status}}</div>
                </Option>
              </Select>
            </Col>
          <Button @click="startAddingCompany" style="float: right;">Add Company</Button>
        </Row>
        <Row :gutter="10" style="margin: 10px 0 -10px 0">
          <Col span="3" class="sum-content">Σ Vehicles: {{totalVehicles}}</Col>
          <Col span="3" class="sum-content">Σ Drivers: {{totalDrivers}}</Col>
          <Col span="4" class="sum-content">Σ TruckOrders: {{totalTruckOrders}}</Col>
          <Col span="4" class="sum-content">Σ OrdersAssigned: {{totalOrdersAssigned}}</Col>
          <Button v-if="isAdmin" @click="exportTransporters" :loading="exportLoading" style="float: right;">Export CSV</Button>
        </Row>

        <Spin fix size="small" v-if="skipTransporters"></Spin>
        <hot-table :settings="hotSettings" v-show="!skipTransporters" style="margin: 20px 0 10px 0"  ref="hotTableComponent">
            <hot-column v-for="(colset, index) in columns" :settings="colset" :key="index">
            </hot-column>
        </hot-table>
        <Page :total="transportersCount" :current="pageNumber" show-sizer @on-change="onChangePage" @on-page-size-change="onChangeSize"></Page>

        <register-company-drawer ref="register-company-form"></register-company-drawer>
        <edit-company-drawer ref="edit-company-form"></edit-company-drawer>

    </div>
</template>

<script>
    import {Constants} from "../../Constants/Constant"
    import {SEARCH_CITY2} from "../../graphql/queries/territories"
    import {SUBSCRIBE_COMPANIES_TOTALCOUNT, SUBSCRIBE_EXCEL_TRANSPORTERS} from "../../graphql/subscription/companies"
    import { HotTable, HotColumn } from '@handsontable/vue'
    import Handsontable from 'handsontable'
    import RegisterCompanyDrawer from "../RegisterCompanyDrawer"
    import {
      actionRenderer,
      addressRenderer, clientStatusRenderer, routesRenderer,
      statusRenderer,
    } from "../ExcelContractors/RendererFunctions";
    import EditCompanyDrawer from "../EditCompanyDrawer";
     import moment from 'moment';
    import {GET_ALL_TRANSPORTERS} from "../../graphql/queries/companies";
    import {getAddressString} from "../ExcelFormattedOrders/RendererFunctions";
    import {getCompanyStatusString} from "../ExcelClients/Settings";

    export default {
        name: "ExcelTransporters",
        components: {EditCompanyDrawer, RegisterCompanyDrawer, HotTable, HotColumn},
        props:['globalSearch'],
        apollo: {
            $subscribe: {
                clientsCount: {
                  query: SUBSCRIBE_COMPANIES_TOTALCOUNT,
                  skip(){return this.skipTransporters},
                  variables () {
                    return {
                      city: this.selectedCity,
                      isApproved: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapApproveStatus[this.selectedStatus]:null,
                      isRejected: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapRejectStatus[this.selectedStatus]:null,
                      companyTypes: [Constants.companyType.transporter],
                      searchFilter: '%' + this.globalSearch + '%'
                    }
                  },
                  result ({ data }) {
                    this.transportersCount = data.clientsCount.aggregate.count;
                    //Actually calling below method isn't the efficient way as
                    // it make graphql calls two times [filter change & offset change]
                    this.onChangePage(1);                                             //Reset offset
                    this.$emit('onCount', this.transportersCount);
                  },
                },
                transporters: {
                    query: SUBSCRIBE_EXCEL_TRANSPORTERS,
                    skip(){return this.skipTransporters},
                    variables () {
                        return {
                            city: this.selectedCity,
                            isApproved: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapApproveStatus[this.selectedStatus]:null,
                            isRejected: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapRejectStatus[this.selectedStatus]:null,
                            searchFilter: '%' + this.globalSearch + '%',
                            typeId: Constants.companyType.transporter,
                            offset: this.offset,
                            limit: this.limit
                        }
                    },
                    result ({ data }) {
                        this.transporters = data.transporters
                        this.prepareSheetData(data.transporters)
                    },
                }
            },
        },
        data: function () {
            return {
                Constants: Constants,
                query_SEARCH_CITY: SEARCH_CITY2,
                transportersCount: 0,
                transporters: [],
                pageNumber: 1,
                offset: 0,
                limit: 10,
                skipTransporters: true,
                city: '',
                skipCity: true, //To Avoid calls at initial
                cityFilter: '%%',
                selectedCity: [],                               //[{city: "Surat"}]
                editCompanyDrawer: false,                       //when add company
                columns: [
                    //table_key_intermediate
                    {
                        title: 'City',
                        data: 'city'
                    },
                    {
                        title:'Company<br> Name',
                        data: 'clientName',
                        renderer: this.transporterNameRenderer
                    },
                    {
                        title:'Routes',
                        data: 'routes',
                        renderer: routesRenderer
                    },
                    {
                        title:'Mobile',
                        data: 'clientMobile'
                    },
                    {
                        title:'Email Id',
                        data: 'clientEmail'
                    },
                    {
                        title:'Address',
                        data: 'clientAddress',
                        renderer: addressRenderer,
                    },
                    {
                        title:'GST No.',
                        data: 'clientGSTIN'
                    },
                    {
                        title:'PAN No.',
                        data: 'clientPAN'
                    },
                    {
                        title:'No. of<br> Vehicles',
                        data: 'numOfVehicles',
                        type: 'numeric'
                    },
                    {
                        title:'No. of<br> Drivers',
                        data: 'numOfDrivers',
                        type: 'numeric'
                    },
                    {
                        title:'Truck<br> Orders',
                        data: 'numOfTruckOrders',
                        type: 'numeric'
                    },
                    {
                        title:'Order<br> Assigned',
                        data: 'ordersAssigned',
                        type: 'numeric'
                    },
                    {
                        title:'Total<br> Billing',
                        data: 'totalBilling',
                        type: 'numeric'
                    },
                    {
                        title:'Due<br> Payment',
                        data: 'duePayment',
                        type: 'numeric'
                    },
                    {
                        title:'Status',
                        data: 'status',
                        renderer: (...args) => clientStatusRenderer(...args, this, 'transporters')
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'transporters', 'onEditCompany'),
                      excludeInExport: true
                    },
                ],
                hotSettings: {
                    data: null,
                    readOnly: true,                             //default all cells readOnly
                    fillHandle: false,
                    copyPaste: false,
                    licenseKey: "non-commercial-and-evaluation",
                    autoRowSize: false,
                    autoColumnSize: false,
                    colWidths: [90, 110, 90, 170, 150, 125, 100, 95, 90, 90, 90, 105, 90, 100, 80, 80],
                    className: "htCenter htMiddle",
                    filters: true,
                    dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
                    columnSorting: { sortEmptyCells: true },
                },
                selectedStatus: null,
                mapApproveStatus:{Active: true, Inactive: false, Pending: false},
                mapRejectStatus:{Active: false, Inactive: true, Pending: false},
                updateCompanyDrawer: false,       //when edit company,
                totalVehicles: 0,
                totalDrivers: 0,
                totalTruckOrders: 0,
                totalOrdersAssigned: 0,
                exportLoading: false
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods: {
            onChangePage(page){
              this.offset = (page -1) * this.limit;
              this.pageNumber = page;
            },
            onChangeSize(size){
              this.limit = size;
              this.offset = (this.pageNumber -1) * this.limit;
            },
            startAddingCompany () {
                this.$refs['register-company-form'].companyType_skip = false;
                this.$refs['register-company-form'].companyRegistrationForm.userType = Constants.companyType.transporter
                this.editCompanyDrawer = true
            },
            transporterNameRenderer(instance, td, row, col, prop, value, cellProperties) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);
                td.style.color = 'blue'
                td.classList.add('order-num-txt')
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let transporter = this.transporters[pRow]
                let self = this
                td.onclick = function() {
                    self.$router.push({ path: '/excel-transporters/'+transporter.id})
                }

            },
            onSearchCity(event){
                this.cityFilter = '%' + this.city + '%';
                this.skipCity = false;
            },
            onSelectCity(city){
                this.selectedCity = [{"city": city}]
            },
            onClearCity(){
                this.selectedCity = []
            },
            prepareSheetData(data, forExport){
                let mainArr = []
                let totalVehicles = 0,totalDrivers = 0,totalTruckOrders = 0,totalOrdersAssigned = 0;

                data.forEach(curnt => {
                    curnt.obj = {
                        city: curnt.address[0].city,
                        clientName: curnt.name,
                        routes: curnt.routes || [],
                        clientMobile: curnt.mobile,
                        clientEmail: curnt.email,
                        clientAddress: getAddressString(curnt.address[0]),
                        clientGSTIN: curnt.gstin,
                        clientPAN: '-',
                        numOfVehicles: curnt.trucks_aggregate.aggregate.count,
                        numOfDrivers: curnt.drivers_aggregate.aggregate.count,
                        numOfTruckOrders: curnt.truckOrders_aggregate.aggregate.count,
                        ordersAssigned: curnt.orders_aggregate.aggregate.count,
                        totalBilling: '-',
                        duePayment: '-',
                        status: forExport?getCompanyStatusString(curnt):curnt.isApproved,
                        action: ''
                    }
                    mainArr.push(curnt.obj)

                    totalVehicles = totalVehicles + curnt.trucks_aggregate.aggregate.count;
                    totalDrivers = totalDrivers + curnt.drivers_aggregate.aggregate.count;
                    totalTruckOrders = totalTruckOrders + curnt.truckOrders_aggregate.aggregate.count;
                    totalOrdersAssigned = totalOrdersAssigned + curnt.orders_aggregate.aggregate.count;
                })
                if(forExport) return mainArr

                this.hotSettings.data = mainArr;
                this.totalVehicles = totalVehicles;
                this.totalDrivers = totalDrivers;
                this.totalTruckOrders = totalTruckOrders;
                this.totalOrdersAssigned = totalOrdersAssigned;
            },
            onEditCompany (row) {
              row['type'] = row.typeByType.id;
              this.$refs['edit-company-form'].companyType_skip = false;
              this.$refs['edit-company-form'].setCompanyForm(row);
              this.updateCompanyDrawer = true
            },
            async exportTransporters(){
              this.exportLoading = true
              let re = /<\/?[^>]+(>|$)/g;                  //Remove html tags if any
              let str = this.columns.filter(h => !h.excludeInExport).map(h=> h.title.replace(re,"")).join(',') + '\n'
              let {data:{company}} = await this.$apollo.query({
                query: GET_ALL_TRANSPORTERS,
                fetchPolicy: 'network-only',
                variables: {
                  city: this.selectedCity,
                  isApproved: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapApproveStatus[this.selectedStatus]:null,
                  isRejected: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapRejectStatus[this.selectedStatus]:null,
                  searchFilter: '%' + this.globalSearch + '%',
                  typeId: Constants.companyType.transporter
                }
              })
              company = this.prepareSheetData(company, true)
              let dataKeys = this.columns.filter(h => !h.excludeInExport).map(h=> h.data)
              company.forEach(c => {
                dataKeys.forEach(k => str = str + '\"' + c[k] + '\"' + ',')               //double quotes to avoid commas within string
                str = str + '\n'
              })

              let blob = new Blob([str], {type: 'text/plain'});
              const a = window.document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = 'Transporters_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              this.exportLoading = false
            }
        },
        mounted(){
            setTimeout(() => {
                this.skipTransporters = false
            }, 500)
        }
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    .filterInput{
        width: 80%;
    }
    .refresh-icon{
        float: right;
        margin: 9px 16px;
        font-size: 14px;
        cursor: pointer;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }
</style>
<style>
    .order-num-txt:hover {
        text-decoration: underline;
    }
    .address-txt{
        width: 145px;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
        /*border: 1px solid #ddd;*/
        margin: 0px 0px 0px 5px;
    }
    .action-edit{
      font-size: 12px;
      color:grey;
      /*margin-right:15px;*/
      cursor: pointer;
    }
    .action-delete{
      font-size: 12px;
      color:red;
      cursor: pointer;
    }
    .action-delete:hover{
      color: #FF8C00;
    }
    .action-edit:hover{
      color: #c0c0c0;
    }
    .sum-content{
      font-size: 14px;
      padding: 10px 0 0 0;
    }
  .poptip{
    /*position: relative;*/
  }
  .poptip .poptip-rel{
    /*position: relative;*/
  }
  .poptip .popper{
    position: absolute;
    /*top: -68px;*/
    /*left: 41px;*/
    display: none;
    background: grey;
    color: white;
    width: 150px;
    /*padding: 7px 0 10px;*/
    /*min-width: 150px;*/
    /*visibility: visible;*/
    /*font-size: 12px;*/
    /*line-height: 1.5;*/
    /*z-index: 1060;*/
    /*width: 100%;*/
    /*background-color: #fff;*/
    /*background-clip: padding-box;*/
    /*border-radius: 4px;*/
    /*box-shadow: 0 1px 6px rgba(0,0,0,.2);*/
    /*white-space: nowrap;*/
  }
  .poptip:hover .popper{
    display: unset;
  }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
